import axios from 'axios';
import store from '@/store'
import { Message } from 'element-ui'
import router from '@/router';

//封装请求方法
function formatReq(type, url, data, config) {
  return new Promise((reslove, reject) => {
    axios({
      method: type,
      url: `${url}`,
      headers: {
        // 'content-Type': 'application/x-www-form-urlencoded',
        'Content-Type': 'application/json',
        "Authorization": "Bearer " + store.state.user.token
        // timeout: 3000
      },
      data: data
    })
      .then(r => {
        
        console.log(r.data.code,'r.data.code')
        if (r.data.code == 200) {
          reslove(r.data);
        }else if(r.data.code == 401){
          store.commit('UPDATE_LOADING', false); //隐藏loading
        store.commit('UPDATE_BTNLOADING', false); //隐藏loading
          Message.closeAll()
          Message({
            type: 'error',
            message: '登录过期，请重新登录'
          });
          if(router.currentRoute.path != '/index'){
            router.push("/index");
          }
          store.commit("UPDATE_ISLOGINFLAG", false);
          
        } else {
          Message.closeAll()
          Message({
            type: 'error',
            message: r.data.msg || r.data.message || '操作失败'
          });
        }
        //这里可以添加指定对应状态码的处理方式,比如登陆过期,res.data.code === '6666' 路由跳转到login
        /* if (r.data.code === '403') {
          Message({
            type: 'warning',
            message: r.data.msg || r.data.message
          });
          window.location.href = r.data.data;
        } else if (r.data.code === '000000') {
          reslove(r.data.data);
        } else if (r.data.succ) {
          reslove(r.data.data);
        } else {
          Message({
            type: 'warning',
            message: r.data.msg || r.data.message
          });
          if (r.data.code != '000000') {
            reject(r.data.message || r.data.msg);
          }
          return r.data;
        } */
      })
      .catch(e => {
        reject(e.message || e.msg);
      });
  });
}
const formatUrl = obj => {
  let params = Object.values(obj).reduce(
    (a, b, i) => `${a}${Object.keys(obj)[i]}=${b}&`,
    '?'
  );
  return params.substring(0, params.length - 1);
};

const Http = {
  get: (url, data) => {
    url = data ? url + formatUrl(data) : url;
    const instance = axios.create({
      headers: {
        "Authorization": "Bearer " + store.state.user.token
      }
    })
    return instance
      .get(`${url}`, data)
      .then(r => {
        if (r.data.code == 200) {
          return r.data;
        }else if(r.data.code == 401){
          store.commit("UPDATE_UPDATESCOREFLAG", false);
          Message.closeAll()
          Message({
            type: 'error',
            message: '登录过期，请重新登录'
          });
          if(router.currentRoute.path != '/index'){
            router.push("/index");
          }
          store.commit("UPDATE_ISLOGINFLAG", false);
          
        } else {
          Message({
            type: 'error',
            message: r.data.msg || r.data.message
          });
          return;
        }

        /* if (r.data.code === '403') {
          Message({
            type: 'warning',
            message: r.data.msg || r.data.message
          });
          window.location.href = r.data.data;
        } else if (r.data.code === '000000') {
          return r.data.data;
        } else {
          Message({
            type: 'warning',
            message: r.data.msg || r.data.message
          });
          return;
        } */
      })
      .catch(e => {
        console.log(e);
      });
  },
  post: (url, data, config) => formatReq('post', url, data, config),
  put: (url, data) => formatReq('put', url, data),
  patch: (url, data) => formatReq('patch', url, data),
  delete: (url, data) => formatReq('delete', url, data),
  export: (url, fileName = 'download.xlsx', data = {}) => {
    if (typeof fileName === 'object') {
      data = fileName;
      fileName = 'download.xlsx';
    }
    return axios({ method: 'post', url, data, responseType: 'blob' })
      .then(res => {
        if (res.type === 'application/json') {
          console.log('文件导出失败: ', res);
          return;
        }
        const href = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = href;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(href);
      })
      .catch(error => {
        console.log('文件导出失败: ', error);
      });
  }
};

export default Http;
/* 
  样例
  async getData(){
    let res = await this.Http.get('url', data);
  }
*/
